// Validation Messages
export const VALIDATION_MESSAGES = {
  PHONE_REQUIRED: 'Phone number is required',
  PHONE_INVALID: 'Please enter a valid phone number',
  EMAIL_REQUIRED: 'Email is required',
  EMAIL_INVALID: 'Please enter a valid email address',
  NAME_REQUIRED: 'Name is required',
  OTP_REQUIRED: 'OTP is required',
  OTP_INVALID: 'Please enter a valid OTP',
  TERMS_REQUIRED: 'You must agree to the terms and conditions',
} as const;

// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  REFRESH_TOKEN: 'refresh_token',
  USER_DATA: 'user_data',
} as const;

// OTP Configuration
export const OTP_CONFIG = {
  LENGTH: 6,
  RESEND_TIMER: 30, // seconds
} as const;

// Form Field Names
export const FORM_FIELDS = {
  NAME: 'name',
  PHONE_NUMBER: 'phone_number',
  EMAIL_ADDRESS: 'email_address',
  OTP: 'otp',
  AGREE: 'agree',
} as const;

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  SERVER_ERROR: 'Server error. Please try again later.',
  AUTH_ERROR: 'Authentication failed. Please login again.',
  TIMEOUT_ERROR: 'Request timed out. Please try again.',
  UNKNOWN_ERROR: 'An unexpected error occurred.',
} as const; 